import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { risapi } from '../api/risapi';
import { AuthContext } from './AuthContext';
import milmaLogo from '../assets/milmalogo.png'; 
import './LoginPage.css';

const LoginPage = () => {
    const [phone_number, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState(null); // New state for errors
    const [isLoading, setIsLoading] = useState(false);  // New state for loading status

    const { user, login } = useContext(AuthContext);
    const navigate = useNavigate();

    // Redirect if already logged in
    if (user) {
        if (user.is_milma_admin) {
            navigate('/milma-admin/home');
        } else {
            navigate('/franchisee_user/home');
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoginError(null); // Clear previous errors
        setIsLoading(true);  // Start loading

        try {
            const response = await risapi.post('/api/login', {
                phone_number,
                password,
            });

            if (response.status === 200) {
                const { access_token } = response.data;
                login(access_token);
                navigate('/franchisee_user/home');
            }
        } catch (error) {
            console.error('Error logging in:', error);
            
            // Extract error message from backend response
            const errorMessage = error.response?.data?.message || 'Something went wrong. Please try again.';
            setLoginError(errorMessage);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    return (
        <div className="login-page-container">
            <div className="container-fluid h-100">
                <div className="row h-100">

                    {/* Left Branding Column */}
                    <div className="col-lg-7 d-none d-lg-flex align-items-center justify-content-center branding-column">
                        <div className="overlay"></div>
                        <div className="branding-content text-center position-relative" style={{ zIndex: 2 }}>
                            <img src={milmaLogo} alt="Milma Logo" className="branding-logo" />
                            <h1 className="branding-title mt-3 text-white">Franchise Portal</h1>
                            <p className="branding-subtitle">Manage your stock, orders, and sales efficiently.</p>
                        </div>
                    </div>

                    {/* Right Form Column */}
                    <div className="col-lg-5 d-flex align-items-center justify-content-center form-column">
                        <div className="form-wrapper animate-fade-in">
                            
                            <div className="text-center mb-4">
                                <h2 className="form-title">Welcome Back</h2>
                                <p className="form-subtitle">Please sign in to your account</p>
                            </div>

                            {/* Error Alert Box */}
                            {loginError && (
                                <div className="alert alert-danger d-flex align-items-center" role="alert">
                                    <i className="fa-solid fa-circle-exclamation me-2"></i>
                                    <div>{loginError}</div>
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="form-floating mb-3">
                                    <input
                                        type="tel"
                                        className={`form-control ${loginError ? 'is-invalid' : ''}`}
                                        id="phoneNumberInput"
                                        placeholder="Enter Phone Number"
                                        value={phone_number}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                    <label htmlFor="phoneNumberInput">Phone Number</label>
                                </div>

                                <div className="form-floating mb-3">
                                    <input
                                        type="password"
                                        className={`form-control ${loginError ? 'is-invalid' : ''}`}
                                        id="passwordInput"
                                        placeholder="Enter Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                    <label htmlFor="passwordInput">Password</label>
                                </div>
                                
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="rememberMeCheck" />
                                        <label className="form-check-label text-muted" htmlFor="rememberMeCheck">
                                            Remember me
                                        </label>
                                    </div>
                                    <a href="#" className="forgot-link">Need Help?</a>
                                </div>

                                <div className="d-grid gap-2">
                                    <button type="submit" className="btn btn-milma-login btn-lg" disabled={isLoading}>
                                        {isLoading ? (
                                            <span><i className="fa fa-spinner fa-spin me-2"></i> Signing In...</span>
                                        ) : (
                                            'Sign In'
                                        )}
                                    </button>
                                    
                                    <Link to="/" className="btn btn-outline-secondary btn-lg mt-2">
                                        Back to Home
                                    </Link>
                                </div>
                            </form>
                            
                            <div className="text-center mt-5">
                                <small className="text-muted">&copy; {new Date().getFullYear()} {process.env.REACT_APP_PROVIDER}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;